import axios from "axios";

import moment = require("moment");

import { CustomerUserStatistics } from "./model";

export const getStatistics = async (): Promise<CustomerUserStatistics> => {
    const response = await axios.get("/api/statistics");
    return {
        ...response.data,
        startDate: moment(response.data.startDate),
        endDate: moment(response.data.endDate)
    };
};
